import React from "react";
import { Index as Insurance_Certificate_Index } from "../../containers/Insurance_Certificate/Index";

export default function Index() {
  return (
    <div>
      <Insurance_Certificate_Index />
    </div>
  );
}
